import { recordUserReferral } from '../../../helpers/referrals/referrals.js'
import { identifyUser } from '../../modules/intercom/intercom.js'
import { loadAppUser } from './load-app-user.js'

const appUserData = {
  appUser: null
}

export const browserAppUser = {
  load: async function () {
    // No need to load if already loaded
    if (!appUserData.appUser) {
      const loadedData = await loadAppUser()
      appUserData.appUser = loadedData || null
    }

    loginUser(appUserData?.appUser)
  },

  data: appUserData,

  isLoggedIn: function () {
    return appUserData.appUser !== null
  },

  logout: function () {
    appUserData.appUser = null

    const compHeaderAuthenticated = document.querySelector('header-authenticated')
    compHeaderAuthenticated.setAttribute('data-loaded', 'true')
  }
}

function loginUser (appUser) {
  console.log('*** loginUser', appUser)
  const compHeaderAuthenticated = document.querySelector('header-authenticated')
  compHeaderAuthenticated.setAttribute('data-loaded', 'true')

  identifyUser(appUser)
  recordUserReferral()
}
